<template>
  <div class="metric-config">
    <div style='margin-bottom: 10px'>主指标</div>
    <form-item tip="默认正值为红色向上箭头，负值为绿色向下箭头，添加标记样式可自定义箭头显示条件" label-width="80" labelAlign="left" label="显示标记">
      <el-switch v-model="temData.showMainMark" size="small" />
    </form-item>
    <template v-if="temData.showMainMark">
      <form-item labelAlign="left" label="标记样式">
        <el-button size="small" @click="handleAddMetricStyleCondition">添加</el-button>
      </form-item>
      <div v-for="(item, index) in temData.metricStyleCondition">
        <arrowCondition
          :data="item"
          :index="index"
          @handleRemove="handleRemoveClick"
        />
      </div>
    </template>
    <div>辅助指标</div>
    <div v-for="(item, index) in temData.assistIndexs" :key="index">
      <div>辅助指标({{ index + 1 }})</div>
      <div class="grid grid-index mt-10">
        <form-item labelTop label-width="80" labelAlign="left" label="字段">
          <el-select v-model="item.indexField" clearable size="small">
            <el-option v-for="item in list" :label="item.name" :value="item.code"></el-option>
          </el-select>
        </form-item>
        <form-item labelTop label-width="80" labelAlign="left" label="说明文案">
          <el-input v-model="item.des" size="small" />
        </form-item>
        <form-item labelTop label-width="80" labelAlign="left" label="显示值">
          <el-select v-model="item.showVal" clearable size="small">
            <el-option v-for="item in showList" :label="item.name" :value="item.value"></el-option>
          </el-select>
        </form-item>

        <form-item labelTop label-width="80" labelAlign="left" label="hover提示文案">
          <el-input v-model="item.hoverTitle" size="small" />
        </form-item>

        <form-item labelTop label-width="80" labelAlign="left" label="hover参考字段">
          <el-select v-model="item.hoverCode" clearable size="small">
            <el-option v-for="item in list" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </form-item>
        <form-item tip="默认正值为红色向上箭头，负值为绿色向下箭头，添加标记样式可自定义箭头显示条件" labelTop label-width="80" labelAlign="left" label="显示标记">
          <el-switch v-model="item.showMark" size="small" />
        </form-item>
      </div>
      <template v-if="item.showMark">
        <form-item labelAlign="left" label="标记样式">
          <el-button size="small" @click="handleAddAssCondition(item)">添加</el-button>
        </form-item>
        <div v-for="(assItem, assIndex) in item.metricStyleCondition">
          <arrowCondition
            :data="assItem"
            :index="assIndex"
            @handleRemove="(idx) => handleRemoveAssCondition(item, idx)"
          />
        </div>
      </template>
    </div>
    <div>
      <el-button size="small" type="primary" v-if="temData.assistIndexs.length" @click="temData.assistIndexs.pop()">删除</el-button>
      <el-button size="small" @click="temData.assistIndexs.push({})">添加</el-button>
    </div>
  </div>
</template>
<script setup>
import { computed, ref } from "vue";
import { deepClone } from "@/echart/util";
import arrowCondition from "./arrowCondition.vue";
let props = defineProps({
  temData: {},
  option: {},
});
let showList = [
  {
    name: "原始值",
    value: "originalVal",
  },
  {
    name: "相差百分比",
    value: "differPCT",
  },
  {
    name: "相差绝对值",
    value: "differAbs",
  },
];

if (!props.temData.assistIndexs) {
  props.temData.assistIndexs = [];
}
const conditionItem = {
  iconType: '',
  color: '',
  conditions: {
    operationSymbol: "and",
    rows: [
      {
        ruletype: "d",
        oper: '',
        ruleVal: '',
        id: "1",
      },
    ],
  }
}
// 这里只能选辅助指标
let list = computed(() => {
  return props.option.assistMetrics || [];
});
const handleAddMetricStyleCondition = () => {
  if (!props.temData.metricStyleCondition) {
    props.temData.metricStyleCondition = [deepClone(conditionItem)]
  } else {
    props.temData.metricStyleCondition.push(deepClone(conditionItem))
  }
}

const handleAddAssCondition = (item) => {
  if (!item.metricStyleCondition) {
    item.metricStyleCondition = [deepClone(conditionItem)]
  } else {
    item.metricStyleCondition.push(deepClone(conditionItem))
  }
}

const handleRemoveAssCondition = (item, idx) => {
  if (item.metricStyleCondition && item.metricStyleCondition.length) {
    item.metricStyleCondition.splice(idx, 1)
  }
}

const handleRemoveClick = (index) => {
  props.temData.metricStyleCondition.splice(index, 1)
}

</script>

<style scoped lang="scss">
.metric-config {
  max-height: 560px;
  overflow-y: scroll;
}
.grid-index {
  grid-template: repeat(2, 1fr) / repeat(3, 1fr);
}
.style-detail {
  display: flex;
}
.style-item {
  padding: 16px;
  background-color: #666666;
  margin-bottom: 10px;
  position: relative;
  .icon {
    position: absolute;
    right: 16px;
    top: 16px;
    color: #ffffff;
  }
}
</style>
